import { $gridColumnsProvider } from 'vue/types/umd'

export interface DxGridColumnConfig {
    dataField: string;
    caption: string;
    dataType: string;
}

export default {
    'listini': [
        {
            dataField: 'nome',
            caption: 'nome',
            dataType: 'string'
        },
        {
            dataField: 'scatto_risposta',
            caption: 'Scatto alla risposta',
            dataType: 'number'
        },
        {
            dataField: 'costo_vs_fisso_italia',
            caption: 'Costo VS fisso (Italia)',
            dataType: 'number'
        },
        {
            dataField: 'costo_vs_mobile_italia',
            caption: 'Costo VS mobile (Italia)',
            dataType: 'number'
        },
        {
            dataField: 'max_minuti_vs_fissi_italiani',
            caption: 'Minuti massimi verso numeri fissi italiani',
            dataType: 'number'
        },
        {
            dataField: 'costo_mese',
            caption: 'Prezzo al mese',
            dataType: 'number'
        },
        {
            dataField: 'listinoEsaurimento.nome',
            caption: 'Listino da applicare ad esaurimento minuti',
            dataType: 'string'
        }
    ] as DxGridColumnConfig[],
    'listiniTariffeInternazionali': [
        {
            dataField: 'listinoRiferimento.nome',
            caption: 'Listino di riferimento',
            dataType: 'string'
        },
        {
            dataField: 'direttrice',
            caption: 'Direttrice',
            dataType: 'string'
        }/*,
        {
            dataField: 'nazione',
            caption: 'Nazione',
            dataType: 'string'
        },
        {
            dataField: 'prefisso',
            caption: 'Prefisso',
            dataType: 'string'
        }*/,
        {
            dataField: 'costo',
            caption: 'Costo',
            dataType: 'number',
            format: {
                type: 'fixedPoint',
                precision: 6
            }
        },
        {
            dataField: 'scatto_risposta',
            caption: 'Scatto alla risposta',
            dataType: 'number',
            format: {
                type: 'fixedPoint',
                precision: 6
            }
        }
    ],
    'utenze': [
        {
            dataField: 'codice',
            caption: 'Codice',
            dataType: 'string'
        },
        {
            dataField: 'nome',
            caption: 'Nome',
            dataType: 'string'
        },
        {
            dataField: 'V_Listino',
            caption: 'Listino',
            dataType: 'string'
        }
    ],
    'numerazioni': [
        {
            dataField: 'numero',
            caption: 'Numero',
            dataType: 'string'
        },
        {
            dataField: 'V_Fornitore',
            caption: 'Fornitore',
            dataType: 'string'
        },
        {
            dataField: 'V_StatoNumerazione',
            caption: 'Stato Numerazione',
            dataType: 'string'
        },
        {
            dataField: 'V_Utenza',
            caption: 'Utenza Collegata',
            dataType: 'string'
        },
        {
            dataField: 'ultima_variazione',
            caption: 'Ultima variazione',
            dataType: 'datetime'
        }
    ],
    'numerazioniStati': [
        {
            dataField: 'descrizione',
            caption: 'Descrizione',
            dataType: 'string'
        }
    ],
    'fornitori': [
        {
            dataField: 'nome',
            caption: 'Nome',
            dataType: 'string'
        }
    ]
}